import React from "react";
import { IconFrame } from "../IconFrame";
import { twClassNames } from "../../helpers/twClassNames";

type PlanCardIncludedItem = { icon: string; text: React.ReactNode; iconColor?: string };

export type PlanCardProps = {
    icon: string;
    iconFrameClassName?: string;
    title: string | React.ReactNode;
    description: React.ReactNode;
    customChip?: React.ReactNode;
    whatsIncludedTitle?: string;
    whatsIncludedItems?: PlanCardIncludedItem[];
    // CTA (optional)
    ctaButton?: React.ReactNode;
    className?: string;
};

export function PlanCard({
    icon,
    title,
    description,
    customChip,
    whatsIncludedTitle = "What's included:",
    whatsIncludedItems,
    ctaButton,
    className
}: PlanCardProps) {
    const baseCardClasses = "settingsRow plan";
    const defaultWhatsIncludedGridCols = "grid-cols-2";

    return (
        <div className={twClassNames(baseCardClasses, className)}>
            <div className="flex flex-1 flex-col gap-4 sm:flex-row sm:gap-5">
                <IconFrame icon={icon} color="purple" size="lg" />
                <div className="mb-1 flex flex-1 flex-col gap-4">
                    <div className="flex flex-col items-start gap-1 text-secondary">
                        {typeof title === "string" ? (
                            <h2 className="text-xl font-semibold capitalize text-primary">
                                {title}
                            </h2>
                        ) : (
                            title
                        )}

                        {typeof description === "string" ? (
                            <p>{description}</p>
                        ) : (
                            <div>{description}</div>
                        )}

                        {customChip && <div className="mt-1">{customChip}</div>}
                    </div>

                    {whatsIncludedItems && whatsIncludedItems.length > 0 && (
                        <div className="flex flex-1 flex-col gap-2 text-primary">
                            <div className="font-medium">{whatsIncludedTitle}</div>
                            <div
                                className={twClassNames(
                                    "grid gap-x-4 gap-y-2 text-secondary",
                                    defaultWhatsIncludedGridCols
                                )}
                            >
                                {whatsIncludedItems.map((item, index) => (
                                    <div key={index} className="flex items-baseline gap-2">
                                        <i
                                            className={twClassNames(
                                                "fa-fw",
                                                item.icon,
                                                item.iconColor || "text-purple-500"
                                            )}
                                        ></i>
                                        <span>{item.text}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {ctaButton}
        </div>
    );
}
